// extracted by mini-css-extract-plugin
export var activeIndex = "FeaturedListBlock-module--activeIndex--76dcc";
export var answer = "FeaturedListBlock-module--answer--e3c68";
export var arrow = "FeaturedListBlock-module--arrow--57779";
export var cMarginTop = "FeaturedListBlock-module--c-margin-top--ac4c4";
export var cPadding = "FeaturedListBlock-module--c-padding--a15d5";
export var cPaddingBottom = "FeaturedListBlock-module--c-padding-bottom--fc66d";
export var cPaddingTop = "FeaturedListBlock-module--c-padding-top--678ba";
export var content = "FeaturedListBlock-module--content--82d72";
export var date = "FeaturedListBlock-module--date--bcf06";
export var disabled = "FeaturedListBlock-module--disabled--7ccac";
export var ellipsis = "FeaturedListBlock-module--ellipsis--04375";
export var featuredSection = "FeaturedListBlock-module--featuredSection--3fcb2";
export var globalSpacing = "FeaturedListBlock-module--global-spacing--b86e9";
export var globalSpacingBottom = "FeaturedListBlock-module--global-spacing-bottom--746e4";
export var globalSpacingTop = "FeaturedListBlock-module--global-spacing-top--33e90";
export var image = "FeaturedListBlock-module--image--691e7";
export var imageWrapper = "FeaturedListBlock-module--imageWrapper--e5b49";
export var index = "FeaturedListBlock-module--index--6f78b";
export var infoImage = "FeaturedListBlock-module--infoImage--f182b";
export var informationContainer = "FeaturedListBlock-module--informationContainer--31a4e";
export var informationItem = "FeaturedListBlock-module--informationItem--0ccc5";
export var informationList = "FeaturedListBlock-module--informationList--dd70f";
export var informationText = "FeaturedListBlock-module--informationText--98615";
export var listItem = "FeaturedListBlock-module--listItem--0ebf7";
export var mainContainer = "FeaturedListBlock-module--mainContainer--46430";
export var maxWidth = "FeaturedListBlock-module--max-width--fcf2c";
export var navButton = "FeaturedListBlock-module--navButton--17991";
export var pagination = "FeaturedListBlock-module--pagination--f3594";
export var para = "FeaturedListBlock-module--para--8b9ce";
export var styleTick = "FeaturedListBlock-module--styleTick--1a536";
export var tag = "FeaturedListBlock-module--tag--eb834";
export var tagWrapper = "FeaturedListBlock-module--tagWrapper--7cf99";
export var title = "FeaturedListBlock-module--title--82949";